module.exports = __webpack_public_path__ + "static/media/ic_remove.1143a5a9.svg";